/**
 * API接口配置文件
 * 所有API地址已自动包含基础网址，直接调用即可
 */

// 基础网址 - 根据实际环境修改
//export const BASE_URL = 'http://120.24.179.149:9090'
export const BASE_URL = 'https://wangbingxuan.com:9090/'

// API接口地址配置（已包含基础网址）
const api = {
	base: `${BASE_URL}`,
    // 多级字典
	dtree: {
		orgtreeList: `${BASE_URL}/prod-api/company/dtree/orgtreeList`,
	},
    // 日常护理
    daily: {
        dailyUp: `${BASE_URL}/prod-api/company/daily`, // 修改
        dailyAdd: `${BASE_URL}/prod-api/company/daily`, // 添加
        dailyGetList: `${BASE_URL}/prod-api/company/daily/list`, // 列表（pageNum,pageSize）
        dailyDel: `${BASE_URL}/prod-api/company/daily/{ids}`, // 根据ID删除
    },
	// 孕期胎儿数据与产检记录
	pregnancy: {
		pregnancyUp: `${BASE_URL}/prod-api/company/pregnancy`, // 修改
		pregnancyAdd: `${BASE_URL}/prod-api/company/pregnancy`, // 添加
        pregnancyGetList: `${BASE_URL}/prod-api/company/pregnancy/list`, // 列表（pageNum,pageSize）
        pregnancyDel: `${BASE_URL}/prod-api/company/pregnancy/{ids}`, // 根据ID删除
	},
    // WHO 0-3岁生长曲线与评估
    who: {
        whoUp: `${BASE_URL}/prod-api/company/who`, // 修改
        whoAdd: `${BASE_URL}/prod-api/company/who`, // 添加
        whoGetList: `${BASE_URL}/prod-api/company/who/list`, // 列表（pageNum,pageSize）
        whoDel: `${BASE_URL}/prod-api/company/who/{ids}`, // 根据ID删除
    },
    // 时光成长日记
    note: {
        noteUp: `${BASE_URL}/prod-api/company/note`, // 修改
        noteAdd: `${BASE_URL}/prod-api/company/note`, // 添加
        noteGetByID: `${BASE_URL}/prod-api/company/note/getInfo`, // 根据ID查询单个
        noteGetList: `${BASE_URL}/prod-api/company/note/list`, // 列表（pageNum,pageSize）
        noteDel: `${BASE_URL}/prod-api/company/note/{ids}`, // 根据ID删除
    },

    // 辅食记录
    food: {
        foodUp: `${BASE_URL}/prod-api/company/food`, // 修改
        foodGetList: `${BASE_URL}/prod-api/company/food/list`, // 列表（pageNum,pageSize）
    },

    // 心情微语
    comment: {
        commentUp: `${BASE_URL}/prod-api/company/comment`, // 修改
        commentAdd: `${BASE_URL}/prod-api/company/comment`, // 添加
        commentGetList: `${BASE_URL}/prod-api/company/comment/list`, // 列表（pageNum,pageSize）
        commentDel: `${BASE_URL}/prod-api/company/comment/{ids}`, // 根据ID删除
        commentUpdatelikes: `${BASE_URL}/prod-api/company/comment/updatelikes`, // 点赞 传微语id 返回likes更新后数值
    },

    // 时光成长相册
    photo: {
        photoUp: `${BASE_URL}/prod-api/company/photo`, // 修改
        photoAdd: `${BASE_URL}/prod-api/company/photo`, // 添加
        photoGetByID: `${BASE_URL}/prod-api/company/photo/getInfo`, // 根据ID查询单个
        photoGetList: `${BASE_URL}/prod-api/company/photo/list`, // 列表（pageNum,pageSize）
        photoDel: `${BASE_URL}/prod-api/company/photo/{ids}`, // 根据ID删除
    },

	// 用户资料
    userinfo: {
        userinfoUp: `${BASE_URL}/prod-api/company/userinfo`, // 修改用户资料
        userinfoGet: `${BASE_URL}/prod-api/company/userinfo/getInfo`, // 获取用户资料
    },

	// 公开数据
	public: {

	},

	// 文件上传
	upload: {
		image: `${BASE_URL}/prod-api/common/upload`,
		file: `${BASE_URL}/prod-api/common/upload`,
	},

    // 系统参数
    system: {
        login: `${BASE_URL}/prod-api/loginByCode`, // 登录
    },

}


export default api